import { css } from 'linaria';
import { AvatarProps } from './avatar';
import { Variables } from '../';

export const theme = css`
    :global() {
        [data-theme='light'] {
            --avatar-border-color: ${Variables.css.grey6};
        }

        [data-theme='dark'] {
            --avatar-border-color: ${Variables.css.catapultWhite};
        }
    }
`;

export const root = css`
    border-color: var(--avatar-border-color);
    border-style: solid;
    color: ${Variables.css.catapultWhite};
    font-weight: 500;
    text-transform: uppercase;
`;

export const shapes: Record<AvatarProps['shape'], string> = {
    square: css`
        border-radius: 4px;
    `,
    rounded: css`
        border-radius: 50%;
    `,
};

export const sizes = {
    'extra-small': css`
        font-size: 8px;
        border-width: 1px;
    `,
    small: css`
        font-size: 12px;
        border-width: 1.5px;
    `,
    medium: css`
        font-size: 16px;
        border-width: 2px;
    `,
    large: css`
        font-size: 26px;
        border-width: 3px;
    `,
    'extra-large': css`
        font-size: 32px;
        border-width: 4px;
    `,
};

export const button = css`
    background: transparent;
    appearance: none;
    margin: 0;
    padding: 0;
    border: 0;
    box-shadow: none;
    transition: box-shadow 0.2s ease-in-out;

    &:active {
        --avatar-background-opacity: 0.8;
    }

    &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 4px ${Variables.css.focusRing};
    }

    &[aria-pressed='true'] {
        --avatar-border-color: ${Variables.css.catapultOrange};
    }
`;
